import router from './router';
import store from './store';
import {
  hasLogined,
  isTwicePwded,
  isInGame,
  parseUserInfoFromCookie,
} from './utils';
import {
  getMyMaps,
  getMyActs,
  getActWhiteState,
} from '@/api/common';
import {
  ensureSecuritySensitiveVerify,
  needsAccountSecurityVerify,
  isAccountSecurityVerified,
} from '@/utils/securitySensitiveVerify';
// 进度条
import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css'; // progress bar style
NProgress.configure({ showSpinner: false });
/*function isTwicePwded() {
  const token = sessionStorage.getItem('token2')
  //console.log('****'+token)
  if(token)  return true
  return false
}   */
// 开关
let hasAddedRoutes = false;
let getMapsIng = false;
let getActsIng = false;
let hasInited = false;

/** 登录后账户安全校验（独立密码 / 短信，本会话仅一次） */
async function ensureLoginSecurityVerified() {
  return true;
  // if (!needsAccountSecurityVerify(store)) {
  //   return true;
  // }
  // if (isAccountSecurityVerified()) {
  //   return true;
  // }
  // try {
  //   await ensureSecuritySensitiveVerify(store, { oncePerSession: true });
  //   return true;
  // } catch (e) {
  //   return false;
  // }
}

/** 已登录用户导航：新账户安全 或 旧二次认证 */
async function handleLoggedInNavigation(next, target) {
  if (!(await ensureLoginSecurityVerified())) {
    next(false);
    return;
  }

  if (needsAccountSecurityVerify(store)) {
    target === undefined ? next() : next(target);
    return;
  }

  if (isTwicePwded()) {
    target === undefined ? next() : next(target);
    return;
  }

  target === undefined ? next() : next(target);
}

router.beforeEach(async (to, from, next) => {
  NProgress.start();
  const isToLogin = to.path === '/login';
  if (hasLogined()) {
    let userInfo = JSON.parse(sessionStorage.getItem('userInfo') || '{}');
    window.MiniService.UserService.init(isInGame ? 1 : 2, userInfo);
    let data = { uin: userInfo.uin };
    if (!hasInited) {
      try {
        hasInited = true;
        if (!getMapsIng) {
          getMapsIng = true;
          getMyMaps({
            json: 1,
          }).then(res => {
            const { code, data } = res;
            if (code === 0 && data.map_info_list) {
              const keys = Object.keys(data.map_info_list);
              const mapList = [];
              for (let i = 0; i < keys.length; i++) {
                mapList.push({
                  label: data.map_info_list[keys[i]]['name'],
                  value: keys[i],
                });
              }
              if (mapList.length) {
                localStorage.setItem(
                  'my_maps_' + userInfo.uin,
                  JSON.stringify(mapList),
                );
              }
            }
            setTimeout(() => {
              getMapsIng = false;
            }, 1200);
          });
        }
        if (!getActsIng) {
          getActsIng = true;
          getMyActs({ json: 1, page: 1, page_size: 30 }).then(res => {
            const { code, data } = res;
            if (code === 0 && data.list.length) {
              localStorage.setItem(
                'my_acts_' + userInfo.uin,
                JSON.stringify(data.list),
              );
            }
            setTimeout(() => {
              getActsIng = false;
            }, 1200);
          });
        }
        const whiteRes = await getActWhiteState();
        console.log('whiteRes----', whiteRes);
        if (whiteRes.code === 0) {
          const authority = whiteRes.data[0].authority;
          if (
            Object.prototype.toString.call(authority).slice(8, -1) === 'Number'
          ) {
            localStorage.setItem('act_canusee' + userInfo.uin, 1);
          } else {
            localStorage.setItem('act_canusee' + userInfo.uin, 0);
          }
        }
      } catch (err) {
        hasInited = false;
        console.error(err);
      }
    }
    // const userInfo1=sessionStorage.getItem('userInfo')
    //  console.log('***---'+userInfo1)
    //console.log('***'+sessionStorage.getItem('userInfo1'))
    // 如果已登录的情况，访问登录页，直接跳到首页
    //  debugger;
    if (isToLogin) {
      await handleLoggedInNavigation(next, { path: '/' });
    } else {
      if (!hasAddedRoutes) {
        hasAddedRoutes = true;
        try {
          await store.dispatch('addAsyncRoutes');
        } catch (e) {
          // 不重置 hasAddedRoutes，避免接口失败引发死循环
          console.error('[permission] addAsyncRoutes failed', e);
        }
        await handleLoggedInNavigation(next, { ...to });
      } else {
        await handleLoggedInNavigation(next, undefined);
      }
    }
    NProgress.done();
  } else {
    // 未登录的情况，允许访问登录页，
    if (isToLogin) {
      next();
    } else {
      next({ path: '/login' });
    }
    NProgress.done();

    // 退出时重置开关
    hasAddedRoutes = false;
  }
});

router.afterEach(() => {
  NProgress.done();
});
